// extracted by mini-css-extract-plugin
module.exports = {"lightbox":"lightbox_lightbox__gAK7D"};